// extracted by mini-css-extract-plugin
module.exports = {"imageTitle":"PostMainImageTitle_imageTitle__2uP9Z","text":"PostMainImageTitle_text__2igrj","chevron":"PostMainImageTitle_chevron__3NTMM"};